import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form__set mb-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label"
}, " Subject ", -1 /* HOISTED */)
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["SimpleModalComponent"], {
    heading: "Start a new discussion",
    onCloseModal: _cache[3] || (_cache[3] = $event => ($setup.emit( 'close-modal' )))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          id: "discussion_subject",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.discussion_subject) = $event)),
          class: "form__input form__input--stretch",
          type: "text",
          name: "discussion_subject",
          placeholder: "Type the subject of the message...",
          disabled: $setup.loading,
          onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.submitNewTag && _ctx.submitNewTag(...args)), ["enter"]))
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3), [
          [_vModelText, $setup.discussion_subject]
        ])
      ]),
      _createVNode($setup["CommentFormComponent"], {
        ref: "comment-form",
        "discussion-id": $setup.discussion.id,
        "hide-buttons": true,
        "comment-type": "discussion",
        onCommentPosted: $setup.finishDiscussionCreation
      }, null, 8 /* PROPS */, ["discussion-id"]),
      ($setup.error_message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.error_message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[2] || (_cache[2] = $event => ($setup.emit( 'close-modal' )))
      }, " Cancel "),
      _createElementVNode("button", {
        class: _normalizeClass(["button button--fill", { 'button--loading' : $setup.loading }]),
        disabled: !$setup.discussion_subject || !$setup.comment_has_content,
        onClick: $setup.createNewDiscussion
      }, " Post ", 10 /* CLASS, PROPS */, _hoisted_5)
    ]),
    _: 1 /* STABLE */
  }))
}